import { puppyForId } from '../game/Puppy';
import type { PuppyId } from '../game/types';

// Maps a puppy roster to the Phaser atlas keys its idle animations need.
// Atlas keys mirror the iOS naming: p{puppyNum}a{animIndex}, animIndex 1..numAnims.
// De-duplicates while preserving first-seen order.
export function atlasKeysForPuppies(ids: PuppyId[]): string[] {
  const keys = new Set<string>();
  for (const id of ids) {
    const { puppyNum, numAnims } = puppyForId(id);
    for (let a = 1; a <= numAnims; a++) keys.add(`p${puppyNum}a${a}`);
  }
  return [...keys];
}
